import _ from 'lodash';
import * as types from '../mutation-types';
import parcel from '../../api/parcel';

const state = {
  statuses: {
    0: '未到倉',
    1: '已到倉',
    2: '已出倉',
    3: '空運中',
    4: '可集運',
    5: '已集運',
    6: '可取貨',
    7: '已取貨',
    99998: '存放逾期',
    99999: '丟失郵包',
  },
  parcels: [],
  claims: [],
  parcelDetail: {},
  parcelCount: {
    0: 0,
    1: 0,
    2: 0,
    3: 0,
    4: 0,
    5: 0,
    6: 0,
    7: 0,
    99998: 0,
    99999: 0,
  },
};

const getters = {};

const actions = {
  parcelClaim({ commit }, params) {
    return parcel.claim(params).then(({ data: response }) => {
      commit(types.RECEIVE_NEW_PARCEL_CLAIM, response.data);
    });
  },
  claimCancel({ commit }, id) {
    return parcel.claimCancel(id).then(() => {
      commit(types.REMOVE_CLAIM, id);
    });
  },
  fetchParcelClaims({ commit }) {
    return parcel.getClaims().then(({ data: response }) => {
      commit(types.RECEIVE_PARCEL_CLAIM, response.data);
      return response.data;
    });
  },
  fetchParcels({ commit }, params) {
    return parcel.getParcels(params).then(({ data: response }) => {
      commit(types.RECEIVE_PARCEL, response);
      return response.data;
    });
  },
  countParcels({ commit }) {
    return parcel.count().then(({ data: response }) => {
      commit(types.RECEIVE_PARCEL_COUNT, response.data);
      return response.data;
    });
  },
  fetchParcelDetail({ commit }, id) {
    return parcel.getParcelId(id).then(({ data: response }) => {
      commit(types.RECEIVE_PARCEL_DETAIL, response.data);
    });
  },
  activePushParcel({ commit }, params) {
    return parcel.postActivePushParcel(params).then(({ data: response }) => {
      commit(types.RECEIVE_PARCEL_DETAIL, response.data);
    });
  },
};

/* eslint no-param-reassign: 0 */
const mutations = {
  [types.RECEIVE_NEW_PARCEL_CLAIM](s, data) {
    s.claims = [...s.claims, data];
    s.parcelCount[0]++;
  },
  [types.RECEIVE_PARCEL_CLAIM](s, data) {
    s.claims = [...data];
    s.parcelCount[0] = s.claims.length;
  },
  [types.REMOVE_CLAIM](s, id) {
    s.claims = _.reject(s.claims, item => item.id === id);
  },
  [types.RECEIVE_PARCEL](s, response) {
    s.parcels = [...response.data];
  },
  [types.RECEIVE_PARCEL_COUNT](s, data) {
    s.parcelCount = { ...s.parcelCount, ...data };
  },
  [types.RECEIVE_PARCEL_DETAIL](s, data) {
    s.parcelDetail = data;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/parcel.js